/**************************************************
 * Nombre:       Dialogo_Despacho
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid2} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import {useAvisos} from "../../Modulo_Avisos/Hooks/useAvisos";
import {useLoaders} from "../../Modulo_Loaders/Hooks/useLoaders";
import logo from '../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import Formulario_Potenciales from "../Formularios/Formulario_Potenciales";
import {Delete} from "@mui/icons-material";
import {borrarDoc} from "../../Servicios/BD/borrarDoc";

const Dialogo_Potenciales = ({datos, cerrar, realizado}) => {
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Avisos, nuevoAviso, terminar} = useAvisos({funcionUno: cerrar, funcionDos: realizado})
    const {Cargador, abrirCargador, setDetener} = useLoaders({logo: logo})


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()
        abrirCargador('Guardando Datos')
        let result = await guardarDoc('potenciales', entidad)
        if (result.res) {
            nuevoAviso({aviso: 'Datos subidos'})
            setTimeout(() => {
                terminar({aviso: 'Datos actualizados con exito'})
            }, 500)
        } else {
            terminar({aviso: 'Ups! no se subieron los datos, intentalo nuevamente', variante: 'error'})
        }


    }

    const borrar = async () => {
        await borrarDoc('potenciales', datos.id)
        terminar({aviso: 'Registro borrado'})
    }

    return (
        <Grid2
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Potenciales props={props}/>
            </Grid2>

            <Grid2 container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid2>

            {datos && datos.id &&
                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <Button
                        onClick={() => borrar()}
                        color={'success'} startIcon={<Delete/>} variant={'text'}>
                        Borrar
                    </Button>
                </Grid2>
            }

        </Grid2>
    )

}
export default Dialogo_Potenciales